import * as msal from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: '3107110a-341d-4ed9-8b1b-56402a6bff43',
        authority: 'https://login.microsoftonline.com/12857881-81b8-4a42-a8d9-b6ceed875e03',
        validateAuthority: true,
        navigateToLoginRequestUrl: true,
        postLogoutRedirectUri: "",
        redirectUri: process.env.VUE_APP_HOME_URL,
    },
    request: {
       scopes: ['api://31cd524c-79e5-430a-9aff-631349cd5b2b/access_as_user','User.Read']
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true
    },
    system: {
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0
    }
};

const loginRequest = {
    scopes: ["api://31cd524c-79e5-430a-9aff-631349cd5b2b/access_as_user", "User.Read"]
}

const feedbackRequest = {
    scopes: ["api://0da54194-f502-4d09-82e5-d3984517876c/access_as_user", "User.Read"]
}

export default {
    msalInstance: null,

    initialize(){
        this.msalInstance = new msal.PublicClientApplication(msalConfig);

        return this.msalInstance.handleRedirectPromise().then((resp) => {
            if (resp !== null) {
                const currentAccounts = this.msalInstance.getAllAccounts();
                this.msalInstance.setActiveAccount(currentAccounts[0]);
            } else {
                // need to call getAccount here?
                const currentAccounts = this.msalInstance.getAllAccounts();
                if (!currentAccounts || currentAccounts.length < 1) {
                    this.signIn();
                } else if (currentAccounts.length > 1) {
                    // Add choose account code here
                    this.msalInstance.setActiveAccount(currentAccounts[0]);
                } else if (currentAccounts.length === 1) {
                    // Comment
                    this.msalInstance.setActiveAccount(currentAccounts[0]);
                }
            }
        }).catch((error) => {
            console.log(error);
        });   
    },
    acquireToken(request) {
        return this.msalInstance.acquireTokenSilent(request).then(function (result) {
            return result;
        }).catch(() => {
            return this.acquireTokenRedirect(request);
        });
    },
    acquireFeedbackToken() {
        return this.msalInstance.acquireTokenSilent(feedbackRequest).then(function (result) {
            return result;
        }).catch(() => {
            return this.acquireTokenRedirect(loginRequest);
        });
    },
    acquireTokenRedirect(request) {
        return this.msalInstance.acquireTokenRedirect(request);
    },
    isAuthenticated(){
        return this.msalInstance.acquireTokenSilent(loginRequest).then(function (result) {
            return result;
        }).catch(() => {
            return this.acquireTokenRedirect(loginRequest);
        });
    },
    getUserProfile() {
        return this.msalInstance.getActiveAccount();
    },
    signIn() {
        this.msalInstance.loginRedirect(loginRequest);
    },
    signOut() {
        this.msalInstance.logoutRedirect();
    }
}